export default "__VITE_ASSET__GbztsOf___"